// @flow
import { deburr, flow, kebabCase } from 'lodash';

const replaceApostrophes = (anchorValue: string) => anchorValue.replace(/['’]/g, '-');

export const cleanAnchor = (anchorValue: string) => {
  return flow([deburr, replaceApostrophes, kebabCase])(anchorValue);
};
